var DownloadUtils;
((DownloadUtils2) => {
  DownloadUtils2.download = (window, url, filename = "download") => {
    const a = window.document.createElement("a");
    const targetUrl = typeof url === "string" ? url : URL.createObjectURL(url);
    a.href = targetUrl;
    a.download = filename;
    a.style.display = "none";
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
    URL.revokeObjectURL(targetUrl);
  };
  DownloadUtils2.csvDownload = (window, datas, config) => {
    const csv = datas.map((row) => {
      return config.headers.map((fieldName) => {
        let value = row[fieldName];
        if (value && typeof value === "object") {
          value = JSON.stringify(value);
        }
        const stringValue = String(value === null || value === void 0 ? "" : value);
        if (stringValue.includes(",") || stringValue.includes('"') || stringValue.includes("\n")) {
          return `"${stringValue.replace(/"/g, '""')}"`;
        }
        return stringValue;
      }).join(",");
    });
    if (config.includeHeader) {
      csv.unshift(config.headers.join(","));
    }
    const csvString = csv.join("\r\n");
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "flag-data.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
})(DownloadUtils || (DownloadUtils = {}));
export {
  DownloadUtils
};
//# sourceMappingURL=DownloadUtils.js.map
